export default __webpack_public_path__ + "static/media/placeholder_store05-it-mobile.572a69a4.png";